export default {
  data: {
    args: {}
  },
  methods: {
    bindData(data) {
      let args = data;

      if (args.work.shareable !== false) {
        args = $.extend(true, {}, data, {
          work: {
            shareable: {
              email_callback: (item) => {
                new Kadenze.AjaxRequest({
                  type: 'POST',
                  url: item.work.share_email_url,
                  data: {emails: item.emails}
                });
              }
            }
          }
        });
      }

      this.args = args;
    }
  }
};

